import { NavigationEnd, Router } from '@angular/router';
import { SpinnerService } from './../../service/spinner.service';
import { MatSort, Sort } from '@angular/material/sort';
import { finalize, Subscription } from 'rxjs';
import { HttpPaginatedDataSource } from './../../utils/HttpPaginatedDataSource';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, ToastController } from '@ionic/angular';
import { UserService } from '@/service/user.service';
import { User } from '@/dto/user/user';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss']
})
export class UserPage implements OnInit, OnDestroy {
  FilterForm: FormGroup;
  public data: HttpPaginatedDataSource<any>;
  public pageIndex = 1;
  public pageSize: number;
  public pageSizeOpts: number[];
  private unsubscribe: Subscription[] = [];
  public sortCol = "date_joined";
  public sortDir = "desc";

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public columnsToDisplay = ['username', 'first_name', 'last_name', 'email', 'is_staff', 'is_active', 'is_superuser', 'Edit'];
  constructor(private formBuilder: FormBuilder, private spinnerService: SpinnerService, public router: Router, private translateService: TranslateService, public alertController: AlertController,
    private toastController: ToastController, private userService: UserService) { }

  async presentAlertConfirm(user) {
    let message = this.translateService.instant("Do you really want to delete that client:") + `<strong>${user.username}</strong> ?`;
    let header = this.translateService.instant("Delete client");
    let yes = this.translateService.instant("Yes");
    let no = this.translateService.instant("No");

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: no,
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: yes,
          id: 'confirm-button',
          handler: () => {
            this.userService.deleteById(user.id).pipe(finalize(() => {
            })).subscribe(async val => {
              const toast = await this.toastController.create({
                message: this.translateService.instant('Delete successfully'),
                duration: 2000
              });
              toast.present()
              this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
            });
          }

        }
      ]
    });

    await alert.present();
  }

  ngOnInit() {
    this.data = new HttpPaginatedDataSource([]);
    this.data.sort = this.sort;
    this.data.paginator = this.paginator;
    this.pageSizeOpts = [5, 10, 15, 20, 100]
    this.pageSize = 15;
    this.pageIndex = 0;

    this.FilterForm = this.formBuilder.group({
      username: [''],
      firstname: [''],
      lastname: [''],
      email: [''],
      superuser: [''],
      staff: [''],
      active: ['true']
    });
    this.unsubscribe.push(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/admin/user') {
        this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
      }
    }));

    this.sort.sortChange.subscribe((sort: Sort) => {
      this.paginator.pageIndex = 0;
      this.pageIndex = 0;
      this.sortCol = sort.active;
      if (this.sortCol === "create_date")
        this.sortCol = "date_joined";
      this.sortDir = sort.direction;
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }

  get f() { return this.FilterForm.controls; }

  private CreateDataFilter(): any {
    const data = new User();
    data.username__icontains = this.f.username.value
    data.first_name__iconstains = this.f.firstname.value
    data.last_name__icontains = this.f.lastname.value
    data.email__icontains = this.f.email.value
    data.is_superuser = this.f.superuser.value
    data.is_staff = this.f.staff.value
    data.is_active = this.f.active.value
    return data;
  }

  filterForm() {
    this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
  }

  onSubmit(pageSize: number, pageIndex: number, dataFilter: any, sortCol: string, sortDir: string) {
    this.spinnerService.show();

    this.unsubscribe.push(
      this.userService.getAdmin(pageIndex, pageSize, dataFilter, this.sortCol, this.sortDir).pipe(finalize(() => {
        this.spinnerService.hide();
      })).subscribe(val => {
        this.data.data = val.data;
        this.data.sort = this.sort;
        this.data._updatePaginator(val.total)
      })
    );
  }

  change(pageEvent: PageEvent) {
    if (this.pageIndex !== pageEvent.pageIndex || this.pageSize !== pageEvent.pageSize) {
      this.pageIndex = pageEvent.pageIndex;
      this.pageSize = pageEvent.pageSize;
      this.data = new HttpPaginatedDataSource([]);
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    }
  }


  public goTo(path) {
    this.router.navigate([path])
  }

  async addnew() {
    this.router.navigate(['/admin/newuser']);
  }

  async editUser(id_user: string) {
    this.router.navigate(['/admin/edituser'], { queryParams: { iduser: id_user } })
  }

}
